import React, { ComponentProps, useEffect } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent';
import { CookieConsentRoot } from './CookieConsent.styles'
import pluginConfig from './CookieConsentConfig';

type CookieConsentOwnProps = ComponentProps<typeof CookieConsentRoot>
export type CookieConsentProps = CookieConsentOwnProps & {}

export const CookieConsentComponent = (_props: CookieConsentProps) => {
  useEffect(() => {
    CookieConsent.run(pluginConfig);
  }, []);

  return (
    <CookieConsentRoot>
      <a href="#" onClick={CookieConsent.showPreferences}>
        Show Cookie Preferences
      </a>
    </CookieConsentRoot>
  );
};

CookieConsentComponent.displayName = 'CookieConsent'
